import styled from "styled-components";

export const SSelectTemplateStep = styled.div`
  background-color: var(--ui-01);
  height: 100%;
`;
